import { Trial, ResponseStatus, ConfigurationTrial } from "@/api/dtos";
import { Dispatch, SetStateAction, createContext } from "react"

export interface ISourceDataFormSettings {
    buttonLinkTarget: 'current' | 'tab' | 'window';
    separateButtons: boolean;
    hideCombined: boolean;
    hideAudit: boolean;
    hideNotesAndQueries: boolean;
    hideFindings: boolean;
    hideReviews: boolean;
    hideVerifications: boolean;
    hideNotApplicables: boolean;
    hidePriorityIcon: boolean;
    hideOpenClinicaLinkWarning?: boolean;
}

export const DefaultSourceDataFormSettings: ISourceDataFormSettings = {
    buttonLinkTarget: 'current',
    separateButtons: false,
    hideCombined: false,
    hideAudit: false,
    hideNotesAndQueries: false,
    hideFindings: false,
    hideReviews: false,
    hideVerifications: false,
    hideNotApplicables: false,
    hidePriorityIcon: false,
    hideOpenClinicaLinkWarning: false
};

export interface ISourceDataFormSettingsContext {
    settings: ISourceDataFormSettings;
    setSettings: Dispatch<SetStateAction<ISourceDataFormSettings>>;
}

export const SourceDataFormSettingsContext = createContext<ISourceDataFormSettingsContext>({
    settings: {
        ...DefaultSourceDataFormSettings
    },
    setSettings: () => {
    }
});

export default SourceDataFormSettingsContext;